<template>
  <div class="switcher__wrapper" @mousemove="moveHandler" @mouseenter="enter = true" @mouseleave="enter = false">
    <button class="switcher" :class="{'switcher--true' : show}" @click="$store.dispatch('toggleShow')" :style="buttonTransform">
      <span class="line"></span>
      <span class="line"></span>
    </button>
  </div>
</template>

<script>

import store from '@/store'
import {mapGetters} from 'vuex'

export default {
  name: 'navSwitcher',
  data() {
    return{
      enter: false,
      mouse: {
        x: 120,
        y: 120
      },
      button: {
        x: 120,
        y: 120
      },
      animationFrame: null
    }
  },
  computed: {
    buttonTransform: function(){
      return {
        transform:`translate(${this.button.x}px, ${this.button.y}px)`
      }
    },
    ...mapGetters({
      show: 'show'
    })
  },
  mounted() {
    this.render()
  },
  methods:{
    moveHandler(e) {
      this.mouse.x = e.clientX
      this.mouse.y = e.clientY - window.innerHeight / 2 + 120
    },
    render() {

      let vx = 120
      let vy = 120

      if(this.enter){
        vx = this.mouse.x < 120 ? this.mouse.x + (Math.abs(this.mouse.x - 120) / 120) * 25 : this.mouse.x - (Math.abs(this.mouse.x - 120) / 120) * 25 
        vy = this.mouse.y < 120 ? this.mouse.y + (Math.abs(this.mouse.y - 120) / 120) * 25 : this.mouse.y - (Math.abs(this.mouse.y - 120) / 120) * 25 
      }

      this.button.x += (vx - this.button.x) *.15
      this.button.y += (vy - this.button.y) *.15

      this.animationFrame = window.requestAnimationFrame(this.render)
    }
  }
}
</script>

<style lang="scss">
.switcher__wrapper{
  position: fixed;
  z-index: 150;
  width: 240px;
  height: 240px;
  left: 0;
  top: calc(50vh - 120px);
  border-radius: 50%;
  .switcher{
    position: absolute;
    top: -30px;
    left: -30px;
    width: 60px;
    height: 60px;
    background-color: var(--black);
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
    border: 2px solid var(--black);
    transition: color .2s var(--easing), background-color .2s var(--easing);
    &.switcher--true{
      background-color: transparent;
      border-color: var(--white);
      opacity: 0.7;
      &:hover{
        opacity: 1;
      }
      .line{
        transform: rotate(-45deg);
        margin: 0;
        margin-top: -1px;
        &:first-child{
          margin-top: 0;          
          margin-bottom: 0;
          transform: rotate(45deg);
        }        
      }
    }
    .line{
      width: 17px;
      height: 1px;
      background: var(--white);
      transform-origin: 50% 50%;
      transition: all .2s var(--easing);
      margin-top: 0px;
      &:first-child{
        margin-top: 0;        
        margin-bottom: 5px;
        transform-origin: 50% 50%;    
      }
    } 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavSwitcher.vue